import React from "react";
import "./ShippingSection.scss";

const ShippingSection = () => {
  return (
    <section className="shipping-section" id="envios">
      <div className="container">
        <div className="shipping-section__wrapper">
          <div className="shipping-section__content">
            <div className="shipping-section__eyebrow">
              Ubicación y entregas
            </div>

            <h2 className="shipping-section__title">
              Estamos en Hidalgo y realizamos entregas en todo México.
            </h2>

            <p className="shipping-section__description">
              En <strong>MAKINARIA DIMA</strong> ofrecemos atención profesional desde nuestras
              instalaciones, brindando confianza y respaldo en cada operación.
              Puedes recoger tu equipo directamente con nosotros o solicitar
              envío a cualquier parte del país. Nos encargamos de que tu
              maquinaria llegue de forma segura, rápida y eficiente. Tu
              inversión está respaldada desde el primer contacto hasta la
              entrega final
            </p>

            <p className="shipping-section__description">
              Si lo prefieres, puedes recoger tu equipo directamente con
              nosotros. También coordinamos envíos a todo México para facilitar
              la entrega de maquinaria a empresas, talleres y negocios en
              distintas zonas del país.
            </p>

            <div className="shipping-section__actions">
              <a
                href={`https://wa.me/525515898591?text=${encodeURIComponent(
                  "Hola, me gustaría recibir más información sobre su maquinaria industrial.",
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="header__cta"
              >
                Solicitar información
              </a>

              <a
                href="tel:5515898591"
                className="shipping-section__btn shipping-section__btn--secondary"
              >
                Llamar ahora
              </a>
            </div>
          </div>

          <div className="shipping-section__side">
            <div className="shipping-section__card shipping-section__card--main">
              <span className="shipping-section__card-label">Ubicación</span>
              <h3>Santiago Tulantepec, Hidalgo</h3>
              <p>
                C. Ingenieros Industriales 272, Col. Ex Hacienda de San
                Francisco Huatengo, 43774.
              </p>
            </div>

            <div className="shipping-section__grid">
              <div className="shipping-section__card">
                <span className="shipping-section__mini-title">Entrega</span>
                <h4>Recoge con nosotros</h4>
                <p>
                  Opción disponible para clientes que prefieren pasar por su
                  equipo.
                </p>
              </div>

              <div className="shipping-section__card">
                <span className="shipping-section__mini-title">Cobertura</span>
                <h4>Envíos nacionales</h4>
                <p>
                  Coordinamos entrega de maquinaria a diferentes puntos de
                  México.
                </p>
              </div>

              <div className="shipping-section__card">
                <span className="shipping-section__mini-title">Contacto</span>
                <h4>55 1589 8591</h4>
                <p>
                  Atención directa para resolver dudas y solicitar información.
                </p>
              </div>

              <div className="shipping-section__card">
                <span className="shipping-section__mini-title">Atención</span>
                <h4>Proceso claro</h4>
                <p>
                  Coordinación ordenada para facilitar compra, entrega o
                  recolección.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShippingSection;
